import * as React from "react";
function SvgPdf(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 4h20v2H2V4zm20 4h-5v8h2v-2.231h2v-2h-2V10h3V8zM9.5 8h5l1 1v6l-1 1h-5V8zm2 2v4h2v-4h-2zM2 8h5l1 1v4l-1 1H4v2H2V8zm2 4h2v-2H4v2zm18 6H2v2h20v-2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgPdf);
export default ForwardRef;
